export default __webpack_public_path__ + "static/media/Gloves of Flowing Water.f2e68979.jpg";